import type { WallInput, WallResult } from "@tasduvar/engine";
import { toSvg, type Transform } from "../geometry";
import { rebarItems } from "../rebar";

const RED = "#B91C1C";

/** Donatı şeması katmanı (betonarme duvar): çubuklar kırmızı, kesite dik çubuklar nokta. */
export function Reinforcement({ t, wall, result }: { t: Transform; wall: WallInput; result: WallResult }): JSX.Element | null {
  const items = rebarItems(wall, result);
  if (!items.length) return null;
  return (
    <g data-part="rebar">
      {items.map((it) => {
        const lp = toSvg(t, it.labelAt);
        return (
          <g key={it.position} data-rebar={it.position}>
            {it.path ? <polyline points={it.path.map((p) => { const s = toSvg(t, p); return `${s.x},${s.y}`; }).join(" ")} fill="none" stroke={RED} strokeWidth={it.position === "stemMainCut" ? 1.2 : 2} strokeLinejoin="round" strokeLinecap="round" /> : null}
            {it.dots ? it.dots.map((p, i) => { const s = toSvg(t, p); return <circle key={i} cx={s.x} cy={s.y} r={1.8} fill={RED} />; }) : null}
            <text x={lp.x} y={lp.y} textAnchor={it.anchor} dominantBaseline={it.anchor === "middle" ? "middle" : undefined} className="text-[10px] num" fill={RED} paintOrder="stroke" stroke="#fff" strokeWidth={3}>{it.label}</text>
          </g>
        );
      })}
    </g>
  );
}
